export const CONTENTFUL_LOCAL_EN = 'en-US';
export const CONTENTFUL_LOCAL_ZH = 'zh-CN';
